import { authActions } from "./authActions";
import { settings } from "./settings";
import { requirements } from "./requirements";
import { filters } from "./filters";
import { products } from "./products";
import { collections } from "./collections";
import { manufacturer } from "./manufacturer";
import { buyerActions } from "./buyerActions";
import { permissions } from "./permissions";
const actions = {
  authActions,
  settings,
  requirements,
  filters,
  products,
  collections,
  manufacturer,
  buyerActions,
  permissions,
};

export default actions;
